module.exports = __webpack_public_path__ + "static/HelveticaNeueLTW1G-Roman-b12b51ed8f4b03d41f8ee64468995939.woff2";